/* eslint-disable no-multi-spaces */
import React, { Fragment, useState } from 'react'
import PropTypes from 'prop-types'
import { Form, Button } from 'react-bootstrap'
import { Pagination } from '@CommonComponents/buttons'
import { useStateValue } from '@State'
import { newSection, updatePageNum } from '../actions'
import { ActionButtonSection } from './ActionButtonSection'
import { toast } from '@CommonComponents/toast'
import { MEModal } from '../../components'
import { METable, itemIdxDisplayer } from '@CommonComponents'

export const SectionsTable = ({ page, tableName }) => {
  const [currentState, dispatch] = useStateValue()

  const [modalOpen, setModalOpen] = useState(false)
  const [newSectionName, setNewSectionName] = useState('')
  const [sectionNameTouched, setSectionNameTouched] = useState(false)
  const [timeOffset, setTimeOffset] = useState('')
  const [offsetAlert, setOffsetAlert] = useState(false)

  const rowData = currentState.sectionRowData
  const sectionCount = currentState.sectionCount
  const pageLimit = currentState.sectionPageLimit

  const toggleModal = () => {
    setModalOpen(!modalOpen)
    setNewSectionName('')
    setSectionNameTouched(false)
    setTimeOffset('')
    setOffsetAlert(false)
  }

  const handleNewSectionNameChange = e => {
    setSectionNameTouched(true)
    setNewSectionName(e.target.value)
  }

  const handleTimeOffsetChange = e => {
    const val = e.target.value
    setTimeOffset(val)
    setOffsetAlert(val.length > 0 && !/\d{1,2}:\d{2}/.test(val))
  }

  const handleFormSubmit = async () => {
    setSectionNameTouched(true)
    if (!newSectionName || offsetAlert) return
    let response = await newSection(newSectionName, timeOffset, dispatch)
    toggleModal()
    if (response.status === 200) {
      toast.success('Successfully added new section.')
    } else {
      toast.error(response.data.error, { autoClose: false })
    }
  }

  const tableColumns = [
    'Section Name',
    'Time Offset',
    'Signup URL',
    'Signup Expiration',
    'Actions',
  ]

  const buildTableData = sectionData => {
    let cellRows = []
    sectionData.map((row, i) =>
      cellRows.push([
        row.secName,
        row.offset,
        <a href={row.signupUrl} key={i}>
          {row.signupText}
        </a>,
        row.expiration,
        <ActionButtonSection
          section={row.id}
          sectionName={row.secName}
          key={i}
        />,
      ])
    )
    return cellRows
  }

  return (
    <Fragment>
      <div className="card-myed">
        <div className="pull-right">
          <a
            className="btn btn-myed btn-default btn-default-myed"
            onClick={toggleModal}
          >
            <div className="fa-light fa-plus fa-fw mr-2" /> Add Section
          </a>
        </div>
        <h3>Sections</h3>
        <p>
          Sections
          {itemIdxDisplayer(
            pageLimit,
            currentState.currentSectionPage,
            rowData.length,
            sectionCount
          )}
          shown
        </p>
        <div className="row p-3">
          <METable
            columns={tableColumns}
            data={buildTableData(rowData)}
            columnCss={{ Actions: 'text-center' }}
          />
          <div className="text-center">
            {Math.ceil(sectionCount / pageLimit) > 1 && (
              <Pagination
                currentPage={page}
                rate={pageLimit}
                total={sectionCount}
                setCurrentPage={selectedPage =>
                  updatePageNum(
                    {
                      page: selectedPage,
                      table: tableName,
                    },
                    dispatch
                  )
                }
              />
            )}
          </div>
        </div>
      </div>
      <MEModal show={modalOpen} close={toggleModal} title="Add Section">
        <form onSubmit={e => e.preventDefault()}>
          <Form.Group controlId="formSectionName">
            <Form.Label>New Section Name (required)</Form.Label>
            <Form.Control
              type="text"
              value={newSectionName}
              onChange={handleNewSectionNameChange}
              isInvalid={sectionNameTouched && !newSectionName}
            />
            {sectionNameTouched && !newSectionName && (
              <small className="text-danger">Section name is required.</small>
            )}
          </Form.Group>
          <Form.Group controlId="formTimeOffset">
            <Form.Label>Time Offset</Form.Label>
            <Form.Control
              type="text"
              value={timeOffset}
              placeholder="0:00"
              onChange={handleTimeOffsetChange}
              isInvalid={offsetAlert}
            />
            {offsetAlert && (
              <div>
                <small className="text-danger">
                  Please enter the time offset in the correct format (H:MM).
                </small>
              </div>
            )}
            <Form.Text>
              Specify the offset for this section in H:MM. All due dates will be
              shifted with this offset when displayed to students.
            </Form.Text>
          </Form.Group>
          <Button
            type="button"
            className="btn-myed btn-primary-myed"
            variant="primary"
            onClick={handleFormSubmit}
          >
            Save
          </Button>
        </form>
      </MEModal>
    </Fragment>
  )
}

SectionsTable.propTypes = {
  tableName: PropTypes.string,
  page: PropTypes.number,
}
